import { Text } from "@fluentui/react/lib/Text";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { FilterToolTipContent } from "Components/Generic/FilterToolTipContent";
import { WithTranslator } from "Components/Generic/Translator";
import { utcNowAsISO } from "Utils/Date";
import { getFormattedValue } from "Utils/Field";
import { isNullOrWhiteSpace } from "Utils/String";
import { TooltipDirection, TooltipCloseDelay, TooltipOpenDelay } from "../TooltipSettings";
import { IDateRendererProps } from "./IDateRendererProps";
import { UseDateRendererStyles } from "./UseDateRendererStyles";

export const DateRenderer = WithTranslator((props: IDateRendererProps): JSX.Element => {
  const {
    item, translator, isRelative, fieldName, styles
  } = props;
  const styleSet = UseDateRendererStyles(styles);
  const neverText = translator.get(`generic.never`, `Never`);
  const formattedDate = getFormattedValue(item, props, translator, neverText);
  const tooltipFormattedDate = getFormattedValue(item, { ...props, isRelative: !isRelative }, translator, neverText);
  const isNeverDate = isNullOrWhiteSpace(item?.[fieldName] as string) || (item?.[fieldName] as string) === `9000-01-01T00:00:00Z`;
  const rawValue = isNeverDate ? `>=${utcNowAsISO()}` : item?.[fieldName];

  return (
    <TooltipHost
      closeDelay={TooltipCloseDelay}
      content={<FilterToolTipContent fieldName={fieldName} value={tooltipFormattedDate} rawValue={rawValue} />}
      delay={TooltipOpenDelay}
      directionalHint={TooltipDirection}
      hostClassName={styleSet.host}
    >
      <div className={styleSet.root}>
        <Text>{formattedDate}</Text>
      </div>
    </TooltipHost>
  );
});
